:host {
    display: block;
}

.failed {
    color: var(--color-error);
}
